import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicButton,
    BaasicTable,
    EmptyState,
    BaasicModal
} from "core/components";
import { isSome } from "core/utils";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";
import { TrackingCaseDocumentFieldValueEditModal } from "application/tracking-case/components";

const TrackingCaseDocumentFieldValueListTemplate = function({ trackingCaseDocumentFieldValueListViewStore }) {
    const { tableStore, routes, authorization, trackingCaseDocumentName, editModal, populate, openDocumentView, goBack } = trackingCaseDocumentFieldValueListViewStore;

    return (
        <ApplicationListLayout
            store={trackingCaseDocumentFieldValueListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                <BaasicButton
                    type='button'
                    className="btn btn--base btn--ghost"
                    onClick={() => goBack()}
                    label={'Back'}
                />
                <BaasicButton
                    type='button'
                    className="btn btn--base btn--primary"
                    onClick={() => populate()}
                    label={'Populate'}
                />
                <BaasicButton
                    type='button'
                    className="btn btn--base btn--primary"
                    onClick={() => openDocumentView()}
                    label={'Document View'}
                />
            </PageNavigation>

            <Content emptyRenderer={renderEmpty(routes)}>
            <h4>{trackingCaseDocumentName}</h4>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>

            <BaasicModal className="modal__content modal--sml" modalParams={editModal}>
                <TrackingCaseDocumentFieldValueEditModal />
            </BaasicModal>
        </ApplicationListLayout>
    );
};

function renderEmpty(routes) {
    return (
        <EmptyState
            title="TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.EMPTY_STATE.TITLE"
            actionLabel="TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.EMPTY_STATE.ACTION"
            callToAction={routes.create}
        />
    );
}

TrackingCaseDocumentFieldValueListTemplate.propTypes = {
    trackingCaseDocumentFieldValueListViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const {
        onEdit
    } = actions;
    if (
        !isSome(onEdit)
    )
        return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--edit u-icon--sml"
                        label="TRACKING_CASE_DOCUMENT_FIELD_VALUE.LIST.ACTIONS.EDIT"
                        onlyIcon={true}
                        onClick={() => onEdit(item)}
                    ></BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(TrackingCaseDocumentFieldValueListTemplate); 